import { render, staticRenderFns } from "./PhotoUnsupportedFormatModal.vue?vue&type=template&id=1384d06c"
import script from "./PhotoUnsupportedFormatModal.vue?vue&type=script&lang=js"
export * from "./PhotoUnsupportedFormatModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports